module.exports = __webpack_public_path__ + "static/img/12.9da9c1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/12.png
// module id = cVVJ
// module chunks = 0